// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5078fddc","732":"3187d60f","977":"8c0b2ce7"}[chunkId] + ".chunk.js";
};